import React from "react";
import Skeleton from "react-loading-skeleton";
import Accordion from "../singlecomponents/Accordion";
import { Course } from "../../compilers/course";
import { Chapter } from "../../compilers/chapter";
import { useTranslation } from "react-i18next";
import Tag from "../tags/Tag";

type CourseSummaryProps = {
  course: Course;
  handleBeginCourseAtChapter: (selectedChapter: number) => void;
};

const CourseSummary: React.FC<CourseSummaryProps> = ({
  course,
  handleBeginCourseAtChapter,
}) => {
  const { t, ready } = useTranslation();

  const getTags = () => {
    if (course.data.tags) {
      return course.data.tags.map((tag) => <Tag key={tag} title={tag} />);
    }
    return;
  };

  const renderChapterPreviews = () => {
    return course.data.body.map((chapter: Chapter, i: number) => {
      return (
        <Accordion
          key={chapter.title}
          ExtraClass="chapter-preview"
          TitleHeader={chapter.title}
          ChapterType={chapter.type}
          AccordionWrapper="chapterPreview"
          AccordionHeading={`chapter-${i}`}
          AccordionCollapse={`chapter-collapse-${i}`}
        >
          <div className="chapter-blurb-container">
            <p className="p2">{chapter.blurb}</p>
            <button
              className={`p2 btn btn-second next-btn`}
              onClick={() => {
                handleBeginCourseAtChapter(chapter.index);
              }}
            >
              {ready ? t("inner-page.read") : ""}
            </button>
          </div>
        </Accordion>
      );
    });
  };

  return (
    <div className="course-summary__info-container__wrapper">
      <div>
        <h3 className="mb-3">
          {ready ? (
            t("inner-page.overview")
          ) : (
            <Skeleton width={300} height={100} />
          )}
        </h3>
        <div className="px-lg-4 course-summary__info-container__info-wrapper">
          <div className="course-summary__info-container__content">
            <h4>
              {ready ? (
                t("inner-page.course-description")
              ) : (
                <Skeleton width={300} height={100} />
              )}
            </h4>
            <div
              className="media-article"
              dangerouslySetInnerHTML={{ __html: course.data.overview }}
            />
          </div>
          <div className="course-summary__info-container__content">
            <h4>
              {ready ? (
                t("inner-page.learning-outcomes")
              ) : (
                <Skeleton width={300} height={100} />
              )}
            </h4>
            <div
              className="media-article"
              dangerouslySetInnerHTML={{ __html: course.data.learningOutcomes }}
            />
            <div className="course-summary__tags-container">{getTags()}</div>
          </div>
        </div>
      </div>
      <div>
        <h3 className="mb-3">
          {ready ? (
            t("inner-page.course-content")
          ) : (
            <Skeleton width={300} height={100} />
          )}
        </h3>
        <div className="accordion px-lg-4" id="chapterPreview">
          {renderChapterPreviews()}
        </div>
      </div>
    </div>
  );
};

export default CourseSummary;
